$(document).ready(function(){

	var $slideshow = $('.slideshow');

	$slideshow.slick({
		prevArrow: '<button type="button" class="slick-prev"><span class="sr-only">Vorheriges</span></button>',
		nextArrow: '<button type="button" class="slick-next"><span class="sr-only">Nächstes</span></button>',
		slidesToShow : 1,
		slidesToScroll: 1,
		arrows : false,
		dots: true,
		slide : '.media',
		adaptiveHeight: true,
		fade: false,
		speed: 500,
		autoplay : false,
		autoplaySpeed : 5000

	});




    // Pause slick slider when video is being played inside a slide
    $slideshow.on(
        'beforeChange',
        function (event, slick, currentSlide, nextSlide) {

            $('video', $slideshow ).each(function () {
                if ($(this).attr('id')) {
                    // console.log( "slickPlay -> video pause" );
                    $video = document.getElementById($(this).attr('id'));
                    $video.pause();
                }
            });

            var $activeSlide = $('.slick-slide.slick-current.slick-active');
            $('iframe', $activeSlide ).each(function () {
                if ($(this).attr('src')) {
                    thisIframeSource = $(this).attr('src');
                    $(this).attr('src', '' );
                    $(this).attr('data-src', thisIframeSource );
                    $(this).attr('src', thisIframeSource );
                }
            });
        }
    );

    $slideshow.on(
        'afterChange',
        function (event, slick, currentSlide, nextSlide) {
            // console.log( "afterChange" );

            var $activeSlide = $('.slick-slide.slick-current.slick-active');

            $video = $activeSlide.find('video');

            if ($video.length > 0) {
                var $topSlide = $(this);

                // We the video’s proper id
                $video = document.getElementById($video.attr('id'));

                if (!$video) {
                    return;
                }

                $video.addEventListener(
                    'play',
                    function () {
                        // console.log( "video play -> slickPause" );
                        $slideshow.slick('slickPause');
                    },
                    false
                );

                $video.addEventListener(
                    'pause',
                    function () {
                        // console.log( "video pause -> slickPlay" );
                        $slideshow.slick('slickPlay');
                    },
                    false
                );

                $video.addEventListener(
                    'ended',
                    function () {
                        // console.log( "video ended -> slickPlay" );
                        $slideshow.slick('slickPlay');
                    },
                    false
                );
            }
        }
    );

});
